import type { SystemStyleObject, ThemingProps } from '@chakra-ui/react'
import { Link as ChakraLink, Icon, Text } from '@chakra-ui/react'
import { faLinkHorizontal } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'
import { Link as ReactRouterLink } from 'react-router'

import { useAuth } from '@/context/AuthContext'

interface OrganizationLinkProps extends ThemingProps {
  ouId?: number
  name?: string
  showId?: boolean
  sx?: SystemStyleObject
}

export const OrganizationLink = ({
  ouId,
  name,
  showId,
  ...rest
}: OrganizationLinkProps) => {
  const { user } = useAuth()

  const to =
    user?.ouId === ouId ? '/organization' : `/organization/${ouId}`

  if (!user?.allowDisplayOrganizationStructure) {
    return <Text {...rest} whiteSpace='preserve nowrap'>{name}</Text>
  }

  return (
    <CustomTooltip
      display='flex'
      placement='bottom-start'
      label={
        <>
          {name}
          <Text as="span" color="gray.500">
            {', '}
            Id: {ouId}
          </Text>
        </>
      }
    >
      <ChakraLink
        as={ReactRouterLink}
        to={to}
        {...rest}
        sx={{ whiteSpace: 'preserve nowrap', color: 'primary.500', ...rest.sx }}
      >
        {name}
        <Icon
          as={FontAwesomeIcon}
          icon={faLinkHorizontal}
          ml={1.5}
          opacity={0.5}
        />
      </ChakraLink>
    </CustomTooltip>
  )
}
